import { Subscribable, Subscription } from '@benzinga/subscribable';
import { Vertical } from './entities';
import { Session } from '@benzinga/session';
import { VerticalRequest } from './request';
import { oneRequestAtATime } from '@benzinga/utils';
import { VerticalsStore } from './store';

export interface VerticalsGetRequestEvent {
  verticals: Vertical[];
  type: 'verticals:get_verticals';
}

export interface VerticalsErrorEvent {
  error: Error | string;
  type: 'verticals:error_verticals';
}

export interface VerticalsUpdateEvent {
  type: 'verticals:update_verticals';
  verticals: Vertical[];
}

export type VerticalsRequestEvent = VerticalsGetRequestEvent | VerticalsErrorEvent | VerticalsUpdateEvent;

export class VerticalsManager extends Subscribable<VerticalsRequestEvent> {
  private request: VerticalRequest;
  private store = new VerticalsStore();
  private storeSubscription?: Subscription<VerticalsStore>;
  private requestSubscription?: Subscription<VerticalRequest>;
  private fetchVertical = oneRequestAtATime(async () => {
    const verticals = await this.request.getVerticals();
    if (verticals.err) {
      return verticals.err;
    } else {
      return this.store.updateVerticals(verticals.ok ?? []);
    }
  });
  constructor(session: Session) {
    super();
    this.request = new VerticalRequest(session);
    this.fetchVertical();
    setInterval(() => this.fetchVertical(), 1000 * 60 * 60 * 24); //24 hr interval for fetching verticals
    session.onPostSessionClose(() => this.requestSubscription?.unsubscribe());
  }

  public static getName = () => 'benzinga-verticals';

  public getVerticalsCached = (): Vertical[] => this.store.getVerticalStoreVerticals();

  public getCachedVerticalByVerticalName = (verticalName: string): Vertical | undefined =>
    this.store.getCachedVerticalByVerticalName(verticalName);

  protected onFirstSubscription(): void {
    this.requestSubscription = this.request.subscribe(event => this.dispatch(event));
    this.storeSubscription = this.store.subscribe(event => this.dispatch(event));
  }

  protected onZeroSubscriptions(): void {
    this.requestSubscription?.unsubscribe();
    this.storeSubscription?.unsubscribe();
  }
}
